import { computed, shallowRef, type Ref } from "vue";

export function useAllFieldsEdited<T extends Record<string, string>>(form: Ref<T>) {
  const baseline = shallowRef<T>({ ...form.value });

  const markPristine = () => {
    baseline.value = { ...form.value };
  };

  const allFieldsEdited = computed(() =>
    (Object.keys(form.value) as (keyof T)[]).every((key) => {
      const value = form.value[key].trim();
      return value !== "" && value !== baseline.value[key].trim();
    })
  );

  return { allFieldsEdited, markPristine };
}
